export class ScrollProgressIndicator {
    constructor(element) {
        this._progressCurrent = 0;
        this._progressMin = 0;
        this._progressMax = 100;
        this._element = element;
    }
    setProgress(progress) {
        this._progressCurrent = Math.round((1000 *
            (progress / (this._progressMax - this._progressMin)))) / 1000;
        this._element.style.width = (this._progressCurrent * 100) + '%';
    }
    show() {
        // Checking is set is not needed, no paint is happening if you set current
        this._element.parentElement?.classList.add('scrolled');
    }
    hide() {
        // Checking is set is not needed, no paint is happening if you set current
        this._element.parentElement?.classList.remove('scrolled');
    }
}
export default ScrollProgressIndicator;
